const MONO = "'JetBrains Mono', monospace";

const HQ = { x: 216, y: 118 };

// Positions projected from real lat/lon (illustrative linear projection)
const CC = [
  { n: "LOS ANGELES", x: 168, y: 65, lx: 158, ly: 69, a: "end", primary: true },
  { n: "PASADENA", x: 198, y: 39, lx: 208, ly: 43, a: "start" },
  { n: "LONG BEACH", x: 187, y: 134, lx: 177, ly: 124, a: "end" },
  { n: "ANAHEIM", x: 253, y: 125, lx: 262, ly: 122, a: "start" },
  { n: "ONTARIO", x: 335, y: 61, lx: 344, ly: 58, a: "start" },
  { n: "RIVERSIDE", x: 388, y: 80, lx: 397, ly: 77, a: "start" },
  { n: "PALM SPRINGS", x: 593, y: 118, lx: 584, ly: 115, a: "end" },
  { n: "SAN DIEGO", x: 440, y: 400, lx: 440, ly: 384, a: "middle", primary: true },
];

const VENUES = [
  { n: "FAIRPLEX", s: "POMONA", x: 290, y: 57, lx: 281, ly: 58, a: "end" },
  { n: "QUEEN MARY", s: "LONG BEACH WATERFRONT", x: 183, y: 152, lx: 183, ly: 176, a: "middle" },
  { n: "OC FAIR & EVENT CENTER", s: "COSTA MESA", x: 258, y: 159, lx: 267, ly: 166, a: "start" },
];

const HARBOR = {
  n: "LAND'S END — BERTH 60",
  s: "HARBOR EVENT VENUE — SAN PEDRO",
  x: 166,
  y: 147,
  lx: 95,
  ly: 205,
  leader: [163, 153, 99, 196],
};

const COAST =
  "M20 62 L42 68 L113 73 L138 126 L165 141 L187 143 L251 161 L288 191 L327 221 L384 276 L416 359 L440 399 L445 420";

const LIST_CC = [
  ["Los Angeles Convention Center", "Downtown LA"],
  ["Pasadena Convention Center", "Pasadena"],
  ["Long Beach Convention & Entertainment Center", "Long Beach"],
  ["Anaheim Convention Center", "Anaheim"],
  ["Ontario Convention Center", "Ontario"],
  ["Riverside Convention Center", "Riverside"],
  ["Palm Springs Convention Center", "Palm Springs"],
  ["San Diego Convention Center", "San Diego"],
];

const LIST_VENUES = [
  ["Land's End — Berth 60, Port of Los Angeles", "Harbor event venue — San Pedro", true],
  ["OC Fair & Event Center", "Costa Mesa", false],
  ["Fairplex", "Pomona", false],
  ["Queen Mary Waterfront", "Long Beach", false],
];

const Dot = ({ color }) => (
  <span
    className="mt-1 h-2 w-2 shrink-0 rounded-full"
    style={{ backgroundColor: color }}
    aria-hidden="true"
  />
);

export default function SoCalMap() {
  return (
    <div>
      <div className="relative border border-white/10 bg-panel p-4 sm:p-6" data-testid="socal-map">
        <span className="absolute left-2 top-2 h-4 w-4 border-l border-t border-white/30" aria-hidden="true" />
        <span className="absolute right-2 top-2 h-4 w-4 border-r border-t border-white/30" aria-hidden="true" />
        <span className="absolute bottom-2 left-2 h-4 w-4 border-b border-l border-white/30" aria-hidden="true" />
        <span className="absolute bottom-2 right-2 h-4 w-4 border-b border-r border-white/30" aria-hidden="true" />

        <svg
          viewBox="0 0 640 440"
          className="h-auto w-full"
          role="img"
          aria-label="Illustrative map of Southern California event venues. Hawaiian Gardens is the highlighted home base. Convention centers in Los Angeles, Pasadena, Long Beach, Anaheim, Ontario, Riverside, Palm Springs and San Diego are marked in white. Event venues including Land's End Berth 60 in San Pedro, OC Fair and Event Center in Costa Mesa, Fairplex in Pomona and the Queen Mary waterfront in Long Beach are marked in violet and acid green."
        >
          <defs>
            <pattern id="mapgrid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M40 0H0V40" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="640" height="440" fill="url(#mapgrid)" />

          <text x="20" y="30" fill="#8E95A2" fontSize="10" fontFamily={MONO} letterSpacing="2">
            32.5°N — 34.3°N / 116.3°W — 119.0°W
          </text>
          <text x="560" y="420" fill="#8E95A2" fontSize="10" fontFamily={MONO} letterSpacing="2">
            FIG. 01
          </text>
          <text x="48" y="330" fill="rgba(142,149,162,0.7)" fontSize="10" fontFamily={MONO} letterSpacing="4">
            PACIFIC OCEAN
          </text>

          <path d={COAST} fill="none" stroke="rgba(245,245,240,0.2)" strokeWidth="1" />

          {[...CC, ...VENUES, HARBOR].map((m) => (
            <line
              key={`line-${m.n}`}
              x1={HQ.x}
              y1={HQ.y}
              x2={m.x}
              y2={m.y}
              stroke="rgba(204,255,0,0.14)"
              strokeWidth="0.75"
              strokeDasharray="2 6"
            />
          ))}

          {CC.map((m) => (
            <g key={m.n}>
              <title>{m.n} Convention Center</title>
              <circle cx={m.x} cy={m.y} r="11" fill="none" stroke="rgba(245,245,240,0.25)" strokeWidth="1" />
              <circle cx={m.x} cy={m.y} r="4.5" fill="#F5F5F0" />
              <g className={m.primary ? "" : "max-md:hidden"}>
                <text x={m.lx} y={m.ly} fill="#F5F5F0" fontSize="10" fontFamily={MONO} letterSpacing="1.5" textAnchor={m.a}>
                  {m.n}
                </text>
              </g>
            </g>
          ))}

          {VENUES.map((m) => (
            <g key={m.n}>
              <title>{`${m.n} — ${m.s}`}</title>
              {m.leader && (
                <line x1={m.leader[0]} y1={m.leader[1]} x2={m.leader[2]} y2={m.leader[3]} stroke="rgba(167,139,250,0.4)" strokeWidth="0.75" />
              )}
              <circle cx={m.x} cy={m.y} r="11" fill="none" stroke="rgba(167,139,250,0.4)" strokeWidth="1" />
              <circle cx={m.x} cy={m.y} r="4.5" fill="#A78BFA" />
              <g className="max-md:hidden">
                <text x={m.lx} y={m.ly} fill="#A78BFA" fontSize="10" fontFamily={MONO} letterSpacing="1.5" textAnchor={m.a}>
                  {m.n}
                </text>
                <text x={m.lx} y={m.ly + 13} fill="#8E95A2" fontSize="8" fontFamily={MONO} letterSpacing="1.5" textAnchor={m.a}>
                  {m.s}
                </text>
              </g>
            </g>
          ))}

          <g>
            <title>Land's End — Berth 60, Port of Los Angeles, San Pedro. Harbor event venue.</title>
            <line x1={HARBOR.leader[0]} y1={HARBOR.leader[1]} x2={HARBOR.leader[2]} y2={HARBOR.leader[3]} stroke="rgba(204,255,0,0.5)" strokeWidth="0.75" />
            <circle cx={HARBOR.x} cy={HARBOR.y} r="14" fill="none" stroke="rgba(204,255,0,0.5)" strokeWidth="1" />
            <circle cx={HARBOR.x} cy={HARBOR.y} r="6" fill="none" stroke="#CCFF00" strokeWidth="2" />
            <text x={HARBOR.lx} y={HARBOR.ly} fill="#CCFF00" fontSize="10" fontFamily={MONO} letterSpacing="1.5" textAnchor="middle">
              {HARBOR.n}
            </text>
            <text x={HARBOR.lx} y={HARBOR.ly + 13} fill="#8E95A2" fontSize="8" fontFamily={MONO} letterSpacing="1.5" textAnchor="middle" className="max-md:hidden">
              {HARBOR.s}
            </text>
          </g>

          <g>
            <title>Triple O home base — 12038 Centralia St, Unit E, Hawaiian Gardens, California</title>
            <line x1={HQ.x - 40} y1={HQ.y} x2={HQ.x + 40} y2={HQ.y} stroke="rgba(204,255,0,0.4)" strokeWidth="1" />
            <line x1={HQ.x} y1={HQ.y - 40} x2={HQ.x} y2={HQ.y + 40} stroke="rgba(204,255,0,0.4)" strokeWidth="1" />
            <circle cx={HQ.x} cy={HQ.y} r="22" fill="none" stroke="rgba(204,255,0,0.3)" strokeWidth="1" />
            <circle cx={HQ.x} cy={HQ.y} r="12" fill="none" stroke="rgba(204,255,0,0.55)" strokeWidth="1" />
            <circle cx={HQ.x} cy={HQ.y} r="6.5" fill="#CCFF00" />
            <text x={HQ.x} y={HQ.y - 40} fill="#CCFF00" fontSize="11" fontFamily={MONO} letterSpacing="2" textAnchor="middle">
              HAWAIIAN GARDENS
            </text>
            <text x={HQ.x} y={HQ.y - 26} fill="#8E95A2" fontSize="8" fontFamily={MONO} letterSpacing="1.5" textAnchor="middle">
              TRIPLE O — HOME BASE
            </text>
          </g>
        </svg>

        <div
          className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-4"
          data-testid="socal-map-legend"
        >
          <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60">
            <span className="h-2 w-2 rounded-full bg-paper" aria-hidden="true" /> Convention Center
          </span>
          <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60">
            <span className="h-2 w-2 rounded-full bg-uv-glow" aria-hidden="true" /> Event Venue
          </span>
          <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60">
            <span className="h-2 w-2 rounded-full bg-acid" aria-hidden="true" /> Triple O — Home Base
          </span>
          <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/60">
            <span className="h-2 w-2 rounded-full border-2 border-acid" aria-hidden="true" /> Harbor Show Example
          </span>
        </div>
      </div>

      <div className="mt-6 grid gap-8 sm:grid-cols-2 md:hidden" data-testid="socal-venue-list">
        <div>
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-paper/60">
            <Dot color="#F5F5F0" /> Convention Centers
          </p>
          <ul className="mt-4 space-y-3">
            {LIST_CC.map(([name, city]) => (
              <li key={name} className="flex items-start gap-3">
                <Dot color="#F5F5F0" />
                <span className="text-sm leading-snug text-paper/85">
                  {name}
                  <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-fog">{city}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-paper/60">
            <Dot color="#A78BFA" /> Event Venues
          </p>
          <ul className="mt-4 space-y-3">
            {LIST_VENUES.map(([name, city, acid]) => (
              <li key={name} className="flex items-start gap-3">
                <Dot color={acid ? "#CCFF00" : "#A78BFA"} />
                <span className="text-sm leading-snug text-paper/85">
                  {name}
                  <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-fog">{city}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
